import { CityResource } from './CityResource';

export class CityListResource {
    citiesList: CityResource[];
}